export default "__VITE_ASSET__BIwP3NW___"